module.exports = __webpack_public_path__ + "img/instagramIcon.9460ded0.png";